// Centralised styles for all PDF outputs – revised header colours
export const pdfStyles = {
    /* Titles & headings */
    header:           { fontSize: 16, bold: true, color: '#0A4DA2', alignment: 'center', margin: [0, 0, 0, 6] },
    subheader:        { fontSize: 12, bold: true, margin: [0, 4, 0, 10] },
    sectionHeader:    { fontSize: 11, bold: true, color: '#0A4DA2', margin: [0, 10, 0, 6] },
  
    /* Narrative text */
    content:          { fontSize: 9, lineHeight: 1.15, margin: [0, 0, 0, 8], alignment: 'justify' },
    italicText:       { fontSize: 9, italics: true },
  
    /* Signatures & footer */
    signatureLabel:   { fontSize: 9, bold: true },
    signatureDate:    { fontSize: 9 },
    footerText:       { fontSize: 8, italics: true, color: '#6B7280' },
  
    /* Tables ---------------------------------------------------------------- */
    // Dark text on light header background to avoid "white‑on‑white" issues when
    // row‐level fillColor overrides the cell‑level fillColor.
    tableHeader:      { fillColor: '#E2E8F0 ', color: '#1E293B', bold: true, fontSize: 8 },
    tableHeaderSmall: { fillColor: '#E2E8F0', color: '#1E293B', bold: true, fontSize: 7 },
  
    // Regular body cells
    tableCell:        { fontSize: 8, margin: [0, 4, 0, 4] },
    tableCellSmall:   { fontSize: 7, color: '#475569', margin: [0, 2, 0, 4] },
  
    /* Highlight extremely low / high ratings */
    tableCellOne:     { fontSize: 8, bold: true, color: '#DC2626', margin: [0, 4, 0, 4] },
    tableCellFive:    { fontSize: 8, bold: true, color: '#065F46', margin: [0, 4, 0, 4] },
    badge:            { fontSize: 8, alignment: 'center', margin: [0, 1, 0, 1] },
  
    /* Misc labels */
    fieldLabel:       { fontSize: 9, bold: true, margin: [0, 2, 0, 0] },
    commentHeader:    { fontSize: 8, italics: true, color: '#6B7280', margin: [0, 5, 0, 1] },
    commentText:      { fontSize: 8, margin: [0, 0, 0, 5] },
  
    /* Large compilation pages */
    mainTitle:        { fontSize: 20, bold: true, margin: [0, 18, 0, 12] },
    compilationSectionTitle: { fontSize: 16, bold: true, margin: [0, 18, 0, 10] },
  
    /* Report‑specific */
    reportTitle:         { fontSize: 14, bold: true },
    reportSubheader:     { fontSize: 10, margin: [0, 0, 0, 2] },
    reportSectionHeader: { fontSize: 11, bold: true, margin: [0, 8, 0, 3] },
    reportContent:       { fontSize: 9, margin: [0, 0, 0, 8], alignment: 'justify' },
  };